module.exports = __webpack_public_path__ + "static/media/Decline-Bid.35e09a83.png";